import { useQuery } from '@tanstack/react-query'

import { ProductListViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

export const useGetCartAlsoBought = (enabled: boolean) => {
    return useQuery<ProductListViewModel[]>({
        queryKey: QueryKeys.PDP.AlsoBoughtCart,
        queryFn: async () =>
            fetchRequest({
                serviceName: 'ntl',
                method: 'GET',
                endpoint: '/carts/_my/also-bought',
            }),
        enabled,
    })
}
